module.exports = __webpack_public_path__ + "static/media/map-figure-6-1.a5b65f22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/m/map-figure-6-1.svg
// module id = 673
// module chunks = 0